import { render, staticRenderFns } from "./1.vue?vue&type=template&id=1995f682&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1995f682')) {
      api.createRecord('1995f682', component.options)
    } else {
      api.reload('1995f682', component.options)
    }
    module.hot.accept("./1.vue?vue&type=template&id=1995f682&", function () {
      api.rerender('1995f682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/add-routes/alternates/1.vue"
export default component.exports